export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY'
}

export type Language = 'EN' | 'FR' | 'ES';

export enum LandingViewState {
  HOME = 'HOME',
  PRODUCT = 'PRODUCT',
  PRICING = 'PRICING',
  ENTERPRISE = 'ENTERPRISE',
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP'
}

export interface Transaction {
  id: string;
  merchantName: string;
  amount: number;
  currency: Currency;
  date: string;
  status: 'completed' | 'pending' | 'failed';
  type: 'incoming' | 'outgoing';
  category: string;
}

export interface Balance {
  currency: Currency;
  amount: number;
  flag: string;
}

export interface ChartData {
  name: string;
  income: number;
  expenses: number;
}

export enum ViewState {
  LANDING = 'LANDING',
  DASHBOARD = 'DASHBOARD',
  TRANSACTIONS = 'TRANSACTIONS',
  CARDS = 'CARDS',
  AI_ASSISTANT = 'AI_ASSISTANT'
}